import React, { Fragment, useEffect, useState } from 'react';
import { getDateInEST } from 'utils/date';

const initialTimer = {
  days: 0,
  hours: 0,
  mins: 0,
  secs: 0,
};

const countdown = (diff) => {
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  let secs = Math.floor((diff % (1000 * 60)) / 1000);

  // Add leading 0.
  if (hours < 10) {
    hours = parseInt(`0${hours}`, 10);
  }

  // Add leading 0.
  if (mins < 10) {
    mins = parseInt(`0${mins}`, 10);
  }

  // Add leading 0.
  if (secs < 10) {
    secs = parseInt(`0${secs}`, 10);
  }

  if (secs < 0) {
    return initialTimer;
  }

  return { days, hours, mins, secs };
};

const timeDiff = (endTime) => {
  const now = getDateInEST(new Date()).getTime();
  const then = getDateInEST(new Date(endTime)).getTime();
  return then - now;
};

const Countdown = ({ endTime }) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const diff = timeDiff(endTime);
    const countdownObj = countdown(diff);
    return countdownObj.secs >= 0 ? countdownObj : initialTimer;
  });

  useEffect(() => {
    const startTimer = (interval) => {
      const diff = timeDiff(endTime);
      const countdownObj = countdown(diff);

      if (countdownObj.days > -1) {
        setTimeLeft(countdownObj);
      } else {
        clearInterval(interval);
        setTimeLeft(initialTimer);
      }
    };

    const interval = setInterval(() => {
      startTimer(interval);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [endTime]);

  return (
    <div className="mt-0.5 flex flex-wrap justify-center">
      {Object.entries(timeLeft).map(([timeUnit, number], index) => (
        <Fragment key={timeUnit}>
          <div className="flex flex-col items-center justify-center">
            <span
              className="body-1-bold countdown-banner-number block w-6 text-center"
              suppressHydrationWarning
            >
              {number}
            </span>
            <span className="text-[10px]">{timeUnit}</span>
          </div>
          {index < 3 && <span className="body-1-bold mx-2">:</span>}
        </Fragment>
      ))}
    </div>
  );
};

const CountdownClockBanner = ({ colorScheme, message, ends, cta }) => (
  <div
    id="countdown-clock-banner"
    className={`relative left-0 right-0 top-0 z-10 p-1 text-center color-${colorScheme}`}
  >
    <span className="body-3-bold">{message}</span>
    <Countdown endTime={ends} />
    {cta.text && (
      <a
        href={cta.href}
        target="_blank"
        rel="noreferrer"
        className="absolute bottom-1 right-3.5 text-[10px] text-inherit underline"
      >
        {cta.text}
      </a>
    )}
  </div>
);

export default CountdownClockBanner;
